import { render } from "./CustomizableSelection.vue?vue&type=template&id=24aa5195&scoped=true"
import script from "./CustomizableSelection.vue?vue&type=script&lang=js"
export * from "./CustomizableSelection.vue?vue&type=script&lang=js"

import "./CustomizableSelection.vue?vue&type=style&index=0&id=24aa5195&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aa5195"]])

export default __exports__